import {
  ChoosePlansContainer,
  ChoosePlansHeadersContainer,
  ChoosePlansHeader,
  ChoosePlansSubText,
  ChooesPlansCardsCarousel
} from './ChoosePlans.styles';
import ChoosePlansNavBar from "components/layout/navigation/ChoosePlansNavBar/ChoosePlansNavBar";
import React, {createRef, useRef, useState} from "react";
import Carousel from "components/carousel/Carousel";
import PlanCard from "components/common/PlanCard/PlanCard";
import {businessPlans, nonProfitsPlans} from "utils/constants/BenevPlans";

interface CarouselProps {
  style?: React.CSSProperties,
  children: React.ReactChild[],
  containerClassName?: string,
  cardClassName?: string,
  rotationInterval?: number,
  autoRotate?: number
}

function ChoosePlans() {
  const [planType, setPlanType] = useState('Business');

  // show plans by type
  // NOTE: DO NOT DELETE, each plan should have their own carousel with a UNIQUE key to prevent the animations from
  // transitioning from the previous state of another carousel component, the key tells React that it is a new instance
  // of the component, rather than the same instance
  const showPlans = (planType: string) => {
    switch (planType) {
      case 'Business':
        return (
          <Carousel planType={planType} setPlanType={setPlanType} key={planType}>
            <PlanCard planJson={businessPlans.entrepreneurLite}/>
            <PlanCard planJson={businessPlans.premium}/>
            <PlanCard planJson={businessPlans.enterprise}/>
          </Carousel>
        );
      case 'Non-Profits':
        return (
          <Carousel planType={planType} setPlanType={setPlanType} key={planType}>
            <PlanCard planJson={nonProfitsPlans.smallNonProfit}/>
            <PlanCard planJson={nonProfitsPlans.mediumNonProfit}/>
            <PlanCard planJson={nonProfitsPlans.largeNonProfit}/>
          </Carousel>
        );
      // case 'School':
      //   return (
      //     <Carousel planType={planType} setPlanType={setPlanType} key={planType}>
      //       <PlanCard planJson={schoolPlans.premiere}/>
      //       <PlanCard planJson={schoolPlans.elite}/>
      //       <PlanCard planJson={schoolPlans.superStar}/>
      //     </Carousel>
      //   );
      // case 'Family':
      //   return (
      //     <Carousel planType={planType} setPlanType={setPlanType} key={planType}>
      //       <PlanCard planJson={familyPlans.familyPlan}/>
      //     </Carousel>
      //   )
    }

    //return <PlanCard planJson={familyPlans.familyPlan}/>
  }

  return (
    <>
      <ChoosePlansNavBar/>

      <ChoosePlansContainer>
        <ChoosePlansHeadersContainer>
          <ChoosePlansHeader>BENEV</ChoosePlansHeader>
          <ChoosePlansSubText>ORGANIZATION PLANS</ChoosePlansSubText>
        </ChoosePlansHeadersContainer>

        {showPlans(planType)}
      </ChoosePlansContainer>
    </>
  )
}

export default ChoosePlans;
